import { HIT_TYPE_EVENT } from 'constants/analytics';
import { AnalyticsEventData } from 'models/analytics';
import { Config } from 'models/config';

export function configureAnalytics(config: Config) {
  ga('create', config.gaTrackingCode, 'auto');
}

export function sendPageView(path: string) {
  const gaObject = {
    hitType: 'pageview',
    page: path
  };
  ga('send', gaObject);
}

export function sendEvent(data: AnalyticsEventData) {
  const gaObject = {
    eventAction: data.action,
    eventCategory: data.category,
    eventLabel: data.label,
    eventValue: data.value,
    hitType: HIT_TYPE_EVENT
  };
  ga('send', gaObject);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helper/analytics.ts